import { selectDeletingPaymentMethod, selectSelectedPaymentMethod } from '../../../../../store/workspace/selectors';
import { deletePaymentMethodThunk } from '../../../../../store/workspace/thunks';
import { setDeleteCardModal } from '../../../../../store/workspace/slice';
import { useDispatch, useSelector } from '../../../../../store/store';
import { RemoveCreditCardIcon } from '../../../../../assets/icons';
import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';

/** Detaches the selected card from the Stripe customer. */
export default function DeleteCard() {
    const dispatch = useDispatch();
    const isLoading = useSelector(selectDeletingPaymentMethod);
    const selectedPaymentMethod = useSelector(selectSelectedPaymentMethod);

    const closeModal = () => dispatch(setDeleteCardModal(false));

    const confirm = () => {
        if (!selectedPaymentMethod) return;

        dispatch(deletePaymentMethodThunk({
            action: 'delete_payment_method',
            pmId: selectedPaymentMethod.id,
        }));
    };

    return (
        <Modal
            size='sm'
            actions='both'
            title='Delete card'
            restrictActionsWidth
            closeFunc={closeModal}
            childClassName={styles.wrapper}
            icon={<RemoveCreditCardIcon />}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Primary',
                onClick: closeModal,
            }}
            confirmButton={{
                text: 'Delete',
                type: 'Error',
                onClick: confirm,
                loading: isLoading,
            }}
        >
            <p>
                Are you sure you want to delete Visa Card
                ending in **** {selectedPaymentMethod?.card.last4}?
            </p>
        </Modal>
    );
};
